// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactFeather from "react-feather";
import * as Utils$Coronate from "./Utils.res.js";
import * as Router$Coronate from "./Router.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Externals$Coronate from "./Externals/Externals.res.js";
import * as HtmlEntities$Coronate from "./HtmlEntities.res.js";
import * as Webapi__Dom__Document from "rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.res.js";
import VisuallyHidden from "@reach/visually-hidden";

var global_title = "Coronate";

function formatTitle(x) {
  if (x === "") {
    return global_title;
  } else {
    return x + " - " + global_title;
  }
}

function windowReducer(state, action) {
  switch (action.TAG) {
    case "SetDialog" :
        return {
                isDialogOpen: action._0,
                isMobileSidebarOpen: state.isMobileSidebarOpen,
                title: state.title
              };
    case "SetSidebar" :
        return {
                isDialogOpen: state.isDialogOpen,
                isMobileSidebarOpen: action._0,
                title: state.title
              };
    case "SetTitle" :
        var title = action._0;
        Belt_Option.forEach(Webapi__Dom__Document.asHtmlDocument(document), (function (__x) {
                __x.title = formatTitle(title);
              }));
        return {
                isDialogOpen: state.isDialogOpen,
                isMobileSidebarOpen: state.isMobileSidebarOpen,
                title: title
              };
    
  }
}

function Window$About(props) {
  return JsxRuntime.jsxs("article", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("img", {
                            alt: "",
                            height: "196",
                            src: Utils$Coronate.WebpackAssets.logo,
                            width: "196"
                          }),
                      style: {
                        textAlign: "center",
                        flex: "0 0 48%"
                      }
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h1", {
                              children: "Coronate",
                              className: "title",
                              style: {
                                textAlign: "left"
                              }
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Last updated on " + process.env.GIT_MODIFIED + "."
                            }),
                        JsxRuntime.jsx("p", {
                              children: JsxRuntime.jsx("a", {
                                    children: "Read the FAQ.",
                                    href: Utils$Coronate.faq_url
                                  })
                            }),
                        JsxRuntime.jsx("p", {
                              children: JsxRuntime.jsxs("a", {
                                    children: [
                                      "View the changelog for new features. ",
                                      JsxRuntime.jsx(ReactFeather.ExternalLink, {})
                                    ],
                                    href: Utils$Coronate.changelog_url
                                  })
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Copyright " + HtmlEntities$Coronate.copy + " John" + HtmlEntities$Coronate.nbsp + "Jackson"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Coronate is free software."
                            }),
                        JsxRuntime.jsxs("p", {
                              children: [
                                JsxRuntime.jsxs("a", {
                                      children: [
                                        "Source code is available ",
                                        JsxRuntime.jsx(ReactFeather.ExternalLink, {})
                                      ],
                                      href: Utils$Coronate.github_url
                                    }),
                                " under the ",
                                JsxRuntime.jsxs("a", {
                                      children: [
                                        "Mozilla Public License 2.0 ",
                                        JsxRuntime.jsx(ReactFeather.ExternalLink, {})
                                      ],
                                      href: Utils$Coronate.license_url
                                    }),
                                "."
                              ]
                            })
                      ],
                      style: {
                        flex: "0 0 48%"
                      }
                    })
              ],
              className: "win__about"
            });
}

var toolbarClasses = "win__titlebar-button button-ghost button-ghost-large";

function Window$TitleBar(props) {
  var dispatch = props.dispatch;
  var isMobileSidebarOpen = props.isMobileSidebarOpen;
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsxs("button", {
                      children: [
                        JsxRuntime.jsx(ReactFeather.Menu, {}),
                        JsxRuntime.jsx(VisuallyHidden, {
                              children: "Toggle sidebar"
                            })
                      ],
                      className: "mobile-only " + toolbarClasses,
                      onClick: (function (param) {
                          dispatch({
                                TAG: "SetSidebar",
                                _0: !isMobileSidebarOpen
                              });
                        })
                    }),
                JsxRuntime.jsx("div", {
                      children: formatTitle(props.title),
                      className: "body-20",
                      style: {
                        left: "0",
                        marginRight: "auto",
                        marginLeft: "auto",
                        overflow: "hidden",
                        position: "absolute",
                        right: "0",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        width: "50%"
                      }
                    }),
                JsxRuntime.jsxs("button", {
                      children: [
                        JsxRuntime.jsx(ReactFeather.HelpCircle, {}),
                        JsxRuntime.jsx(VisuallyHidden, {
                              children: "About Coronate"
                            })
                      ],
                      className: toolbarClasses,
                      onClick: (function (param) {
                          dispatch({
                                TAG: "SetDialog",
                                _0: true
                              });
                        })
                    })
              ],
              className: "app__header"
            });
}

function $$Window(props) {
  var match = React.useReducer(windowReducer, {
        isDialogOpen: false,
        isMobileSidebarOpen: false,
        title: ""
      });
  var state = match[0];
  var isMobileSidebarOpen = state.isMobileSidebarOpen;
  var dispatch = match[1];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Window$TitleBar, {
                      isMobileSidebarOpen: isMobileSidebarOpen,
                      title: state.title,
                      dispatch: dispatch
                    }),
                props.children(dispatch),
                JsxRuntime.jsxs(Externals$Coronate.Dialog.make, {
                      isOpen: state.isDialogOpen,
                      onDismiss: (function () {
                          dispatch({
                                TAG: "SetDialog",
                                _0: false
                              });
                        }),
                      ariaLabel: "About Coronate",
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Close",
                              className: "button-micro",
                              onClick: (function (param) {
                                  dispatch({
                                        TAG: "SetDialog",
                                        _0: false
                                      });
                                })
                            }),
                        JsxRuntime.jsx(Window$About, {})
                      ],
                      className: "win__about-dialog"
                    })
              ],
              className: props.className + " " + (
                isMobileSidebarOpen ? "mobile-sidebar-open" : "mobile-sidebar-closed"
              )
            });
}

function noDraggy(e) {
  e.preventDefault();
}

function Window$DefaultSidebar(props) {
  var dispatch = props.dispatch;
  return JsxRuntime.jsx("nav", {
              children: JsxRuntime.jsxs("ul", {
                    children: [
                      JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                  children: [
                                    JsxRuntime.jsx(ReactFeather.Home, {}),
                                    JsxRuntime.jsx("span", {
                                          children: HtmlEntities$Coronate.nbsp + "Home",
                                          className: "sidebar__hide-on-close"
                                        })
                                  ],
                                  to_: "Index",
                                  onDragStart: noDraggy,
                                  onClick: (function (param) {
                                      dispatch({
                                            TAG: "SetSidebar",
                                            _0: false
                                          });
                                    })
                                })
                          }),
                      JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                  children: [
                                    JsxRuntime.jsx(ReactFeather.Award, {}),
                                    JsxRuntime.jsx("span", {
                                          children: HtmlEntities$Coronate.nbsp + "Tournaments",
                                          className: "sidebar__hide-on-close"
                                        })
                                  ],
                                  to_: "TournamentList",
                                  onDragStart: noDraggy,
                                  onClick: (function (param) {
                                      dispatch({
                                            TAG: "SetSidebar",
                                            _0: false
                                          });
                                    })
                                })
                          }),
                      JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                  children: [
                                    JsxRuntime.jsx(ReactFeather.Users, {}),
                                    JsxRuntime.jsx("span", {
                                          children: HtmlEntities$Coronate.nbsp + "Players",
                                          className: "sidebar__hide-on-close"
                                        })
                                  ],
                                  to_: "PlayerList",
                                  onDragStart: noDraggy,
                                  onClick: (function (param) {
                                      dispatch({
                                            TAG: "SetSidebar",
                                            _0: false
                                          });
                                    })
                                })
                          }),
                      JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                  children: [
                                    JsxRuntime.jsx(ReactFeather.Settings, {}),
                                    JsxRuntime.jsx("span", {
                                          children: HtmlEntities$Coronate.nbsp + "Options",
                                          className: "sidebar__hide-on-close"
                                        })
                                  ],
                                  to_: "Options",
                                  onDragStart: noDraggy,
                                  onClick: (function (param) {
                                      dispatch({
                                            TAG: "SetSidebar",
                                            _0: false
                                          });
                                    })
                                })
                          }),
                      JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsxs(Router$Coronate.Link.make, {
                                  children: [
                                    JsxRuntime.jsx(ReactFeather.Clock, {}),
                                    JsxRuntime.jsx("span", {
                                          children: HtmlEntities$Coronate.nbsp + "Time calculator",
                                          className: "sidebar__hide-on-close"
                                        })
                                  ],
                                  to_: "TimeCalculator",
                                  onDragStart: noDraggy,
                                  onClick: (function (param) {
                                      dispatch({
                                            TAG: "SetSidebar",
                                            _0: false
                                          });
                                    })
                                })
                          })
                    ],
                    style: {
                      margin: "0"
                    }
                  })
            });
}

function sidebarCallback(dispatch) {
  return JsxRuntime.jsx(Window$DefaultSidebar, {
              dispatch: dispatch
            });
}

function Window$Body(props) {
  var __sidebarFunc = props.sidebarFunc;
  var footerFunc = props.footerFunc;
  var sidebarFunc = __sidebarFunc !== undefined ? __sidebarFunc : sidebarCallback;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: sidebarFunc(props.windowDispatch),
                      className: "win__sidebar"
                    }),
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: "win__content"
                    }),
                footerFunc !== undefined ? JsxRuntime.jsx("footer", {
                        children: footerFunc(),
                        className: "win__footer"
                      }) : null
              ],
              className: "winBody " + (
                footerFunc !== undefined ? "winBody-hasFooter" : ""
              ) + ")"
            });
}

var Body = {
  make: Window$Body
};

var make = $$Window;

export {
  Body ,
  make ,
}
/* react Not a pure module */
